import React from "react";
import "../../../css/Template2FoodCard.css";
import { useNavigate } from "react-router-dom";

export default function Template2Food({ data, previewUrl, clickable = true }) {
	const navigate = useNavigate();

	const handleClick = () => {
		if (!clickable) return;

		navigate("/offer-list", {
			state: {
				category: data.category || "all",
				subCategory: data.subCategory || "all",
			},
		});
	};
	const navigateToOfferDetails = () => {
		navigate("/offer-details", {
			state: { data: data },
		});
	};

	return (
		<div className="offer-card my-1">
			<div className="offer-image-wrapper" onClick={handleClick}>
				<img
					src={data.image || previewUrl}
					alt="offer"
					className="offer-image"
				/>

				<div className="overlay"></div>

				<div className="offer-badge">
					<div className="badge-value">
						{data.offerType === "flat" && `₹${data.offerValue} OFF`}

						{data.offerType === "percent" &&
							`${data.offerValue}% OFF`}

						{data.offerType === "bogo" && "BUY 1 GET 1"}

						{data.offerType === "combo" && "COMBO OFFER"}
					</div>
				</div>

				<div className="offer-content">
					<h2 className="offer-title">{data.title}</h2>

					<p className="offer-desc">{data.description}</p>

					<div className="offer-valid">
						📅 Valid: {data.startDate} - {data.endDate}
					</div>

					<div className="d-d-inline-block">
						<button className="t2-claim-btn">Claim Offer</button>
					</div>
					<div
						onClick={(e) => {
							e.stopPropagation();
							navigateToOfferDetails();
						}}
					>
						<span>Know More</span>
					</div>
				</div>
			</div>
		</div>
	);
}
